






















































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
/* 以下画面固有 */
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
import { orderUsersModule } from '../../Kanri/store/modules/OrderUsers'; // ストアモジュール
import { ITree } from '../../Kanri/store/dto/Organization'; // dto
import { uketsukeManagementModule } from '../store/modules/UketsukeManger';
import { applicationFormModule } from '../store/modules/ApplicationForm';
//2024/01/12 [2023L-14] add start
import { processHistoriesModule } from '../store/modules/ProcessHistories';
//2024/01/12 [2023L-14] add end
import { supervisingModule } from '@/store/modules/OperationSupervising';
// 定数
import { ApplicationProcessType} from '../fixed/ApplicationProcessType';
import { UketsukeConstants } from '../fixed/UketsukeConstants';
import { UketsukeScreenName } from '../fixed/UketsukeScreenName';
import { AuthoritiesId } from '@/CommonUtils/fixed/AuthoritiesId';
import { loadingControlModule } from '@/store/modules/LoadingControl';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class ApplicationTraderSearch extends ApiAccessBase {
  // 拡張パネルの設定（検索条件）
  private searchPanel: number[] = [0];  //初期表示展開
  // 検索結果ヘッダの設定
  private headers = [{}];
  //ID設定変数
  private createElementId: string = '';
  private searchElementId: string = '';
  // ページネーション部品の初期値設定
  private page = 1;  // 初めに表示するページの番号（基本的に1で固定）
  private itemPerPage = 10; // 1ページあたりに表示するレコードの数
  private pageCount =  0; // ページカウントの初期化(0固定)
  // 権限
  private continueAuthority: boolean = false;
  private changeAuthority: boolean  = false;
  private shoriAuthority: boolean = false;
  //2023/12/12 [2023L-06] add start
  private cancelAuthority: boolean  = false;
  //2023/12/12 [2023L-06] add end
  //20220614 ishida データ検索画面調達区分追加 Start
  private title: string = '';
  //20220614 ishida データ検索画面調達区分追加 End
  // 2023/12/19 [2023L-12] add start
  private isApplicationTypeDisabled: boolean = true;
  private items: any = [];
  private options: any = [];
  private reviewStatusValue: string = '';
  private hachukikanValue: string = '';
  // 2023/12/19 [2023L-12] add end

  // 画面初期化処理
  // component生成時に実行
  private created() {
    this.screenTitle = 'データ検索';
    const processTypeCorrect = ApplicationProcessType.CORRECT;
    // 使用する可変項目の名前を指定(複数指定可)
    if (applicationFormModule.CHECK_TYPE_CONST) {
      this.createElementId = 'search_app_const';
      this.searchElementId = 'search_result_app_const';
      //20220614 ishida データ検索画面調達区分追加 Start
      this.title = this.screenTitle + '（建設工事）';
      //20220614 ishida データ検索画面調達区分追加 End
    } else if (applicationFormModule.CHECK_TYPE_CONSUL) {
      this.createElementId = 'search_app_consul';
      this.searchElementId = 'search_result_app_consul';
      //20220614 ishida データ検索画面調達区分追加 Start
      this.title = this.screenTitle + '（建設コンサル）';
      //20220614 ishida データ検索画面調達区分追加 End
    } else {
      this.createElementId = 'search_app_goods';
      this.searchElementId = 'search_result_app_goods';
      //20220614 ishida データ検索画面調達区分追加 Start
      this.title = this.screenTitle + '（物品・役務）';
      //20220614 ishida データ検索画面調達区分追加 End
    }
    this.setVariablecolsState([this.createElementId]);
    const path: string = UketsukeConstants.APP_TARDER_PATH + '/init/search';

    // 権限情報の取得
    this.continueAuthority = this.checkAuthority(AuthoritiesId.APP_CREATE);
    this.changeAuthority = this.checkAuthority(AuthoritiesId.APP_UPDATE);
    this.shoriAuthority = this.checkAuthority(AuthoritiesId.APP_CREATE);
    //2023/12/12 [2023L-06] add start
    this.cancelAuthority = this.checkAuthority(AuthoritiesId.APP_DELETE);
    //2023/12/12 [2023L-06] add end

    // 2023/12/19 [2023L-12] add start
    this.axiosApi
      .get(path, this.formData)
      .then((response) => {
      })
      .catch((error) => {
        this.errorMessage = error.response.data.code + ':' + error.response.data.message + '\n';
      })
      .finally(() => {
        // ローディングの終了
        loadingControlModule.endLoading();
      });
    // 2023/12/19 [2023L-12] add end

    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        //検索結果.ボタンの設定
        this.headers.shift(); //先頭の空白列削除
        //検索結果.DBから展開
        for (const item of this.variablecols[this.searchElementId] ) {
          this.headers.push({text: item.label,
                            align: item.align,
                            sortable: item.sortable,
                            value: item.name,
                            width: item.width,
                            } );
        }
        this.headers.push(
        // 2023/12/19 [2023L-12] upd start
        {text: '操作メニュー', align: 'center', sortable: false, value: 'continue', width: 90},
        // {text: '継続申請', align: 'center', sortable: false, value: 'continue', width: 90},
        // {text: '変更申請', align: 'center', sortable: false, value: 'change', width: 90},
        // {text: '履歴', align: 'center', sortable: false, value: 'history', width: 90},
        // 2023/12/19 [2023L-12] upd end
        {text: '処理', align: 'center', sortable: false, value: 'check', width: 90},
        );
        // 2023/12/19 [2023L-12] add start
        //審査団体、審査状況のリスト設定
        this.options = this.colInfo.hachukikanNo.options;
        this.items = this.colInfo.reviewStatus.options;
        // 2023/12/19 [2023L-12] add end
        // 再検索
        if (applicationFormModule.CHECK_RE_SEARCH) {
          this.formData = applicationFormModule.GET_FORM_DATA;
          this.syncFormDataToVariableCols();
          // 2023/12/19 [2023L-12] add start
          //colInfoのフォームの復元
          this.hachukikanValue = this.formData['hachukikanNo'];
          this.reviewStatusValue = this.formData['reviewStatus'];
          // 2023/12/19 [2023L-12] add end
          // 2023/12/19 [2023L-12] upd start
          //this.search();
          this.search2();
          // 2023/12/19 [2023L-12] upd end
          // 2023/12/19 [2023L-12] add start
          this.onChangeGroup(this.formData.hachukikanNo);
          // 2023/12/19 [2023L-12] add end
        }
      }
    });
  }

 // 2023/12/19 [2023L-12] add start
 /**
  * セレクトボックス（審査団体）非活性-活性
  * 　　　　　　　　　　　　　　プルダウン表示
  */
  private onChangeGroup( $event: any ) {
    if ( $event !== '' ) {
      this.isApplicationTypeDisabled = false;
    } else if ( $event === '' ) {
      this.isApplicationTypeDisabled = true;
      this.reviewStatusValue = '';
    }
 }
 // 2023/12/19 [2023L-12] add end

  /**
   * 申請情報の編集（継続申請ボタン押下時）
   */
  private dataEditContinue(traderId : string , changeType : string) {
    applicationFormModule.setTraderId(traderId);
    applicationFormModule.setChangeType(changeType);
    applicationFormModule.setProcessType(ApplicationProcessType.CONTINUE);
    this.dataEdit(traderId);
  }

  /**
   * 申請情報の編集（変更申請ボタン押下時）
   */
  private dataEditChange(traderId : string , changeType : string) {
    applicationFormModule.setTraderId(traderId);
    applicationFormModule.setChangeType(changeType);
    applicationFormModule.setProcessType(ApplicationProcessType.CHANGE);
    this.dataEdit(traderId);
  }

  /**
   * 審査状況の閲覧（審査状況ボタン押下時）
   */
  private editReview(traderId : string) {
    // 排他チェック
    this.apiAccess(UketsukeConstants.APP_TARDER_PATH + '/exclusive/' + traderId, Constants.API_METHOD_POST, false, null)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        applicationFormModule.setTraderId(traderId);
        // 遷移元設定
        applicationFormModule.setTransitionSourceScreen(UketsukeScreenName.SEARCH_APPLICATION_TRADER);
        router.push({ name: 'applicationReviewStatus' });
      } else {
        // TOPへジャンプ
        this.hrefElement('appTraderSearch', -50);
      }
    });
  }
  //2023/12/12 [2023L-06] add start
  /**
   * 申請取消
   */
  private cancelo(traderId : string ) {
    if (window.confirm(Message.I0037)) {
       // 共通パス
      const path = Constants.UKETSUKE_URL + '/application/' + applicationFormModule.GET_APP_TYPE + '/cancelo/' + ApplicationProcessType.CANCEL + '/' + traderId;
      // APIアクセス
      this.apiAccess(path, Constants.API_METHOD_POST, true, null)
      .then((result) => {
        if (result === Constants.API_RESULT_SUCCES) {
          // 再検索前にメッセージ保持
          const successMessage = this.infoMessage;
          // 再検索
          // 2023/12/19 [2023L-12] upd start
          //this.search();
          this.search2();
          // 2023/12/19 [2023L-12] upd end
          // 再検索後にメッセージ格納
          this.infoMessage = successMessage;
        }
      });
    }
  }
  //2023/12/12 [2023L-06] add end

  /**
   * 履歴の閲覧（履歴ボタン押下時）
   */
  private editHistory(traderId : string) {
    applicationFormModule.setTraderId(traderId);
    // 遷移元設定
    applicationFormModule.setTransitionSourceScreen(UketsukeScreenName.SEARCH_APPLICATION_TRADER);
    router.push({ name: 'applicationChangeLog' });
  }

  /**
   * 申請情報の編集（業者名押下時）
   */
  private dataEditCompName(traderId : string , changeType : string , referenceFlg : boolean) {
    applicationFormModule.setTraderId(traderId);
    applicationFormModule.setChangeType(changeType);
    applicationFormModule.setIsSubmitEnd(false);
    // 「入力中（業者）」「申請書提出」「受理」か、参照権限のみ(編集権限無し)の場合
    if ( referenceFlg === true || (this.continueAuthority === false && this.changeAuthority === false)) {
      applicationFormModule.setProcessType(ApplicationProcessType.CHECK);
      this.dataCheck(traderId);
    } else {
      applicationFormModule.setProcessType(ApplicationProcessType.CORRECT);
      this.dataEdit(traderId);
    }
  }
  /**
   * 申請情報の編集(共通)
   */
  private dataEdit(traderId : string) {
    this.apiAccess(UketsukeConstants.APP_TARDER_PATH + '/exclusive/' + traderId, Constants.API_METHOD_POST, false, null)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        // 遷移元設定
        applicationFormModule.setTransitionSourceScreen(UketsukeScreenName.SEARCH_APPLICATION_TRADER);
        router.push({ name: 'applicationForm' });
      } else {
        // エラーの場合、セットした項目を削除
        this.hrefElement('appTraderSearch', -50);
        applicationFormModule.setTraderId('');
        applicationFormModule.setChangeType('');
      }
    });
  }
  /**
   * 申請情報の参照(共通)
   */
  private dataCheck(traderId : string) {
    applicationFormModule.setTransitionSourceScreen(UketsukeScreenName.SEARCH_APPLICATION_TRADER);
    router.push({ name: 'applicationForm' });
  }

  /**
   * 添付書類の受付確認
   */
  private checkAppAccept(traderId : string ) {
    this.apiAccess(UketsukeConstants.APP_TARDER_PATH + '/exclusive/' + traderId, Constants.API_METHOD_POST, false, null)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        applicationFormModule.setTraderId(traderId);
        router.push({ name: 'checkAppAccept' });
      } else {
        // TOPへジャンプ
        this.hrefElement('appTraderSearch', -50);
      }
    });
  }

  /**
   * ステータス更新（申請書提出→一次審査中）
   */
  private updateExam(traderId : string ) {
    // 2024/05/31 [2023L-AT-0011] upd start
    if (window.confirm(Message.I028)) {
    //  this.apiAccess(UketsukeConstants.APP_TARDER_PATH + '/exclusive/' + traderId, Constants.API_METHOD_POST, false, null)
    //  .then((result) => {
    //    if (result === Constants.API_RESULT_SUCCES) {
        //pathに通し番号（traderID）付与
        const path = UketsukeConstants.CHECK_APP_ACEPT_PATH + '/' + applicationFormModule.GET_APP_TYPE + '/update/primaryExam/' + traderId;
        // 更新処理
        this.apiAccess(path, Constants.API_METHOD_POST, false, null)
        .then((resultUpdate) => {
          if (resultUpdate === Constants.API_RESULT_SUCCES) {
            //this.apiAccess(UketsukeConstants.APP_TARDER_PATH + '/exclusive/delete/' + traderId, Constants.API_METHOD_POST, false, true);
            this.search2();
          }
        });
    //    }
    //  });
    }
    // 2024/05/31 [2023L-AT-0011] upd end
  }

  // 2023/12/19 [2023L-12] add start
  /**
   * 申請情報の検索
   * 検索前にformDataにhachukikanNoとreviewStatusを格納する。
   */
  private search2() {
    this.formData['hachukikanNo'] = this.hachukikanValue;
    this.formData['reviewStatus'] = this.reviewStatusValue;
    this.search();
  }
  // 2023/12/19 [2023L-12] add end

  /**
   * 申請情報の検索
   * (検索ボタン押下時に発火)
   */
  private search() {
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    this.apiAccess(UketsukeConstants.APP_TARDER_PATH + '/' + applicationFormModule.GET_APP_TYPE + '/' + this.searchElementId, Constants.API_METHOD_POST, true, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        applicationFormModule.setFormData(this.formData);
        // 検索一覧の先頭へジャンプ
        this.hrefElement('searchResults', -50);
      } else {
        // TOPへジャンプ
        this.hrefElement('appTraderSearch', -50);
      }
    });
  }

  /**
   * 検索条件のクリア
   */
  private reset() {
    this.resetForm(this.$refs.form);
    this.resultData = [];
    applicationFormModule.resetFormData();
    const path: string = UketsukeConstants.APP_TARDER_PATH + '/init/search';
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
      }
      // 2023/12/19 [2023L-12] add start
      this.isApplicationTypeDisabled = true;
      // 2023/12/19 [2023L-12] add end
    });
  }

  //2024/01/12 [2023L-14] add start
  /**
   * 申請履歴検索の閲覧（申請履歴検索ボタン押下時）
   */
    private historiesSearch() {
      // 遷移元設定
      processHistoriesModule.setTransitionSourceScreen(UketsukeScreenName.SEARCH_APPLICATION_TRADER);
      router.push({ name: 'processHistoriesSearch' });
    }

  /**
   * 申請履歴の閲覧（申請履歴ボタン押下時）
   */
  private historieso(traderId : string ) {
    processHistoriesModule.setTraderId(traderId);
    // 遷移元設定
    processHistoriesModule.setTransitionSourceScreen(UketsukeScreenName.SEARCH_APPLICATION_TRADER);
    router.push({ name: 'processHistories' });
  }
  //2024/01/12 [2023L-14] add end
}
